(function () {
  angular
    .module("app")
    .controller("leastCostModalController", ["$scope", "$uibModalInstance", "ALKMaps", "data", "$timeout", "$q", "$window", "$filter", "mapService", "UserProvider",
      function leastCostModalController($scope, $uibModalInstance, ALKMaps, data, $timeout, $q, $window, $filter, mapService, userProvider) {
        ALKMaps.APIKey = userProvider.getUser().authToken;

        var trackDisplays = [{
            color: "#00ff06",
            title: "Practical"
          },
          {
            color: "#fe9300",
            title: "Practical, Toll Avoid"
          },
          {
            color: "#027ffb",
            title: "Shortest"
          },
          {
            color: "#a55fff",
            title: "Shortest, Toll Avoid"
          },
          {
            color: "#2448ff",
            title: "Fastest"
          },
          {
            color: "#fc5800",
            title: "Fastest, Toll Avoid"
          }
        ];
        var trackStrokeWidth = 10;
        var selectedTrackOpacity = 1;
        var otherTrackOpacity = 0.4;

        var map = null;
        var leastCostLayers = []; // Total 6 layers at most
        var trackConfigs = [];
        var modalOptions = {
          closeButtonText: "Cancel",
          actionButtonText: "OK",
          okOnly: false,
          headerText: "Least Cost Routing - " + data.route.name,
          bodyText: "",
          bodyTemplate: "/app/modal/leastCostDialog.template.html",
          data: {
            routes: trackConfigs
          }
        };

        var convertTimeStrToNum = function (str) {
          var items = str.split(":");
          return parseInt(items[0]) * 60 + parseInt(items[1]);
        };

        var updateRoutesConfigs = function (reportLines) {
          var minMiles = reportLines[0].Miles;
          var minHours = reportLines[0].Hours;
          var minCosts = reportLines[0].Cost;
          var minTolls = reportLines[0].Tolls;
          for (var lcIndex = 0; lcIndex < reportLines.length; lcIndex++) { // Todo: exclude Fastest? Remove the IF statement if not
            //if (reportLines[lcIndex].LeastCostTripOptions !== "Fastest Tolls Allowed" && reportLines[lcIndex].LeastCostTripOptions !== "Fastest Avoid Tolls") {
            if (reportLines[lcIndex].Miles < minMiles) {
              minMiles = reportLines[lcIndex].Miles;
            }
            if (convertTimeStrToNum(reportLines[lcIndex].Hours) < convertTimeStrToNum(minHours)) {
              minHours = reportLines[lcIndex].Hours;
            }
            if (reportLines[lcIndex].Cost < minCosts) {
              minCosts = reportLines[lcIndex].Cost;
            }
            if (reportLines[lcIndex].Tolls < minTolls) {
              minTolls = reportLines[lcIndex].Tolls;
            }
            //}
          }

          for (var rptIndex = 0; rptIndex < reportLines.length; rptIndex++) { // Todo: exclude Fastest? Remove the IF statement if not
            //if (reportLines[rptIndex].LeastCostTripOptions !== "Fastest Tolls Allowed" && reportLines[rptIndex].LeastCostTripOptions !== "Fastest Avoid Tolls") {
            var trackConfig = {
              tripOptionName: reportLines[rptIndex].LeastCostTripOptions,
              miles: reportLines[rptIndex].Miles,
              hours: reportLines[rptIndex].Hours,
              costs: reportLines[rptIndex].Cost,
              tolls: reportLines[rptIndex].Tolls,
              fuel: reportLines[rptIndex].Fuel,
              labor: reportLines[rptIndex].Labor,
              other: reportLines[rptIndex].Other,
              estghg: reportLines[rptIndex].Estghg,
              checked: true,
              minMiles: reportLines[rptIndex].Miles === minMiles ? true : false,
              minHours: reportLines[rptIndex].Hours === minHours ? true : false,
              minCosts: reportLines[rptIndex].Cost === minCosts ? true : false,
              minTolls: reportLines[rptIndex].Tolls === minTolls ? true : false,
            };

            if (trackConfig.tripOptionName === "Practical Tolls Allowed") {
              trackConfig.dispOptions = trackDisplays[0].title;
              trackConfig.routingOptions = {
                routingType: 0,
                tollDiscourage: false
              };
              trackConfig.strokeColor = trackDisplays[0].color;
            }
            if (trackConfig.tripOptionName === "Practical Avoid Tolls") {
              trackConfig.dispOptions = trackDisplays[1].title;
              trackConfig.routingOptions = {
                routingType: 0,
                tollDiscourage: true
              };
              trackConfig.strokeColor = trackDisplays[1].color;
            }
            if (trackConfig.tripOptionName === "Shortest Tolls Allowed") {
              trackConfig.dispOptions = trackDisplays[2].title;
              trackConfig.routingOptions = {
                routingType: 1,
                tollDiscourage: false
              };
              trackConfig.strokeColor = trackDisplays[2].color;
            }
            if (trackConfig.tripOptionName === "Shortest Avoid Tolls") {
              trackConfig.dispOptions = trackDisplays[3].title;
              trackConfig.routingOptions = {
                routingType: 1,
                tollDiscourage: true
              };
              trackConfig.strokeColor = trackDisplays[3].color;
            }
            if (trackConfig.tripOptionName === "Fastest Tolls Allowed") {
              trackConfig.dispOptions = trackDisplays[4].title;
              trackConfig.routingOptions = {
                routingType: 2,
                tollDiscourage: false
              };
              trackConfig.strokeColor = trackDisplays[4].color;
            }
            if (trackConfig.tripOptionName === "Fastest Avoid Tolls") {
              trackConfig.dispOptions = trackDisplays[5].title;
              trackConfig.routingOptions = {
                routingType: 2,
                tollDiscourage: true
              };
              trackConfig.strokeColor = trackDisplays[5].color;
            }
            if (data.route.options.routingType === trackConfig.routingOptions.routingType &&
              data.route.options.tollDiscourage === trackConfig.routingOptions.tollDiscourage) {
              trackConfig.strokeColor = data.route.color;
              trackConfig.selected = true;
            }
            trackConfigs.push(trackConfig);
            //}
          }
        };

        var getStops = function (transform) {
          var stops = [];
          for (var sIndex = 0; sIndex < data.route.stops.length; sIndex++) {
            var stop = data.route.stops[sIndex];
            var lonLat;
            if (transform === true) {
              lonLat = new ALKMaps.LonLat(stop.Coords.Lon, stop.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), map.getProjectionObject());
            } else {
              lonLat = [stop.Coords.Lon, stop.Coords.Lat]; //[[-75.173297, 39.942892], [-74.438942, 39.362469]];
            }
            stops.push(lonLat);
          }
          return stops;
        };

        var modifyRouteOptions = function (config) {
          var rOptions = angular.copy(data.route.options);
          rOptions.routingType = config.routingType;
          rOptions.tollDiscourage = config.tollDiscourage;
          return rOptions;
        };

        var createLayers = function () {
          var layers = [];
          //layers.push(data.baseMap);
          for (var index = 0; index < trackConfigs.length; index++) {
            var leastCostLayer = new ALKMaps.Layer.Routing(trackConfigs[index].tripOptionName, {
              isDraggable: false,
              originURL: "",
              waypointURL: "",
              destinationURL: ""
              //waypointURL: ALKMaps.IMAGE.FLAG_STOP
            });
            leastCostLayers.push(leastCostLayer);
            layers.push(leastCostLayer);
          }
          //layers.push(data.trafficLayer);
          return layers;
        };

        var cleanup = function () {
          //data.trafficLayer.destroy();
          //data.baseMap.destroy();
          for (var lIndex = 0; lIndex < leastCostLayers.length; lIndex++) {
            leastCostLayers[lIndex].destroy();
          }
          //map.destroy();
        };

        var addRoutesToLayers = function (input) {
          var promises = input.map(function (rt) {
            var deferred = $q.defer();
            rt.layer.addRoute({
              stops: getStops(true),
              routeOptions: rt.routeOptions,
              functionOptions: {
                routeId: rt.layer.name,
                async: true,
                success: function (resp) {
                  //draw stops
                  for (var i = 0; i < data.route.stops.length; i++) {
                    var fontColor = $filter("colorFilter")(rt.strokeColor, "lighten", 0.25);
                    var fillColor = "#FFFFFF";
                    var strokeColor = $filter("colorFilter")(rt.strokeColor, "lighten", 0.2);
                    if (i === 0) {
                      fontColor = "#259800";
                      strokeColor = "#279E00";
                    } else if (i === data.route.stops.length - 1 && !rt.routeOptions.hubRouting) {
                      fontColor = "#e25656";
                      strokeColor = "#be2525";
                    }

                    rt.layer.setRouteHandle(rt.layer.name, i, {
                      externalGraphic: "",
                      fontColor: fontColor,
                      fontSize: "11",
                      fontWeight: "700",
                      strokeColor: strokeColor,
                      pointRadius: "9",
                      strokeWidth: 3,
                      fillColor: fillColor,
                      label: data.route.stops[i].IconText
                    });
                  }
                  deferred.resolve(resp);
                },
                failure: function (resp) {
                  deferred.reject(resp);
                },
                frameRoute: false,
                style: {
                  strokeWidth: trackStrokeWidth,
                  strokeColor: rt.strokeColor
                }
              }
            });

            return deferred.promise;
          });

          var qAll = $q.all(promises);
          qAll.then(function (results) { // jshint ignore:line
            var maxExtent = null;
            map.resetLayersZIndex();
            for (var qIndex = 0; qIndex < leastCostLayers.length; qIndex++) {
              if (maxExtent === null) {
                maxExtent = new ALKMaps.Bounds();
              }

              var leastCostLayer = leastCostLayers[qIndex];
              for (var fIndex = 0; fIndex < leastCostLayer.features.length; fIndex++) {
                var fbounds = leastCostLayer.features[fIndex].geometry.getBounds();
                maxExtent.extend(fbounds);
              }
              for (var opIndex = 0; opIndex < trackConfigs.length; opIndex++) {
                if (trackConfigs[opIndex].tripOptionName === leastCostLayer.name) {
                  if (trackConfigs[opIndex].selected === true) {
                    leastCostLayer.setOpacity(selectedTrackOpacity);
                    map.setLayerZIndex(leastCostLayer, 100);
                  } else {
                    leastCostLayer.setOpacity(otherTrackOpacity);
                  }
                }
              }
            }

            map.zoomToExtent(maxExtent, false);
          }, function (error) { // jshint ignore:line
            // Todo: show this error to where?
          });
        };

        var doHeavyLoading = function () {
          //map = new ALKMaps.Map("leastcostMap");
          map = mapService.getMap("leastcostMap");
          //map.addControl(new ALKMaps.Control.TouchZoom());
          var onSuccess = function (mreport) {
            var dest = mreport[0].Destination.Address;
            dest = dest.City + ", " + dest.State + " " + dest.Zip;
            var origin = mreport[0].Origin.Address;
            origin = origin.City + ", " + origin.State + " " + origin.Zip;
            modalOptions.bodyText = modalOptions.bodyText + " Origin: " + origin + " Destination: " + dest;
            updateRoutesConfigs(mreport[0].ReportLines);
            map.addLayers(createLayers());
            var routesConfigs = [];
            for (var confIndex = 0; confIndex < trackConfigs.length; confIndex++) {
              routesConfigs.push({
                layer: leastCostLayers[confIndex],
                routeOptions: modifyRouteOptions(trackConfigs[confIndex].routingOptions),
                strokeColor: trackConfigs[confIndex].strokeColor
              });
            }
            addRoutesToLayers(routesConfigs);
          };

          var onFailure = function (response) {
            if (response.responseText) {
              var respJson = JSON.parse(response.responseText);
              var msg = "";
              for (var index = 0; index < respJson.length; index++) {
                var err = respJson[index];
                msg = msg + err.Description + "\n\n";
              }
              /* alert(response.status + " " + response.statusText + "\n\n" + msg); 
               Todo: show this error on page? */
            }
          };

          var reportStops = getStops(false);
          var routeOption = data.route.options;
          var reportOptions = {
            dataVersion: "current", //Todo
            type: "leastCost",
            format: "json"
          };
          ALKMaps.Services.getReports({
            "coords": reportStops,
            "options": routeOption,
            "reportOptions": reportOptions,
            "success": onSuccess,
            "failure": onFailure
          });
        };

        $scope.modalOptions = modalOptions;

        $scope.changeTrackVisibility = function (track) {
          for (var vIndex = 0; vIndex < leastCostLayers.length; vIndex++) {
            if (leastCostLayers[vIndex].name === track.tripOptionName) {
              leastCostLayers[vIndex].setVisibility(track.checked);
              break;
            }
          }
        };

        $scope.selectRow = function (track) {
          for (var hIndex = 0; hIndex < trackConfigs.length; hIndex++) {
            if (trackConfigs[hIndex].dispOptions === track.dispOptions) {
              trackConfigs[hIndex].selected = true;
            } else {
              trackConfigs[hIndex].selected = false;
            }
          }
          map.resetLayersZIndex();
          for (var hsIndex = 0; hsIndex < leastCostLayers.length; hsIndex++) {
            if (leastCostLayers[hsIndex].name === track.tripOptionName) {
              leastCostLayers[hsIndex].setOpacity(selectedTrackOpacity);
              map.setLayerZIndex(leastCostLayers[hsIndex], 100);
            } else {
              leastCostLayers[hsIndex].setOpacity(otherTrackOpacity);
            }
          }
        };

        $timeout(doHeavyLoading, 100);

        $scope.modalOptions.ok = function (result) { // jshint ignore:line
          var selectedObj;
          for (var rIndex = 0; rIndex < trackConfigs.length; rIndex++) {
            if (trackConfigs[rIndex].selected === true) {
              selectedObj = trackConfigs[rIndex];
            }
          }
          cleanup();
          $uibModalInstance.close({
            routingType: selectedObj.routingOptions.routingType,
            tollDiscourage: selectedObj.routingOptions.tollDiscourage
          });
        };

        $scope.modalOptions.close = function (result) { // jshint ignore:line
          cleanup();
          $uibModalInstance.dismiss("cancel");
        };
      }
    ]);

})();



// WEBPACK FOOTER //
// ./app/route/leastCost.controller.js